<template>
    <div id="nilai-reagen-create">
      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <vx-card class="mb-base" title="Setting Laboratorium">
            <vue-form-generator
              tag="div"
              :schema="schema"
              :model="model"
              :options="formOptions"
              @model-updated="listen"
            ></vue-form-generator>
          </vx-card>
        </div>
      </div>
      <div class="vx-col w-full" vs-justify="center">
        <vs-row vs-w="12" vs-type="flex" vs-justify="center">
          <vs-button
            class="mr-4 mb-4"
            color="danger"
            @click="$router.go(-1)"
            >
            Batal
          </vs-button>
          <vs-button
            class="mr-4 mb-4"
            icon-pack="feather"
            color="#6488e4"
            @click="onConfirm"
            >
            Simpan
          </vs-button>
        </vs-row>
  		</div>

      <vs-prompt class="w50"
        title="Form Nilai Normal"
        @accept="saveNilaiNormal"
        @cancel="cancelNilaiNormal"
        accept-text="Simpan"
        cancel-text="Batal"
        :active.sync="activePrompt">
           <vx-card>
             <div class="vx-col w-full mb-2">
              <vs-row>
                <vs-col vs-w="6">
                  <vs-input name="ageMin" label="Batas Umur Bawah" class="w-5/6" v-model="ageMin"/>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-input name="ageMax" label="Batas Umur Atas" class="w-5/6" v-model="ageMax"/>
                </vs-col>
              </vs-row>
              <vs-row class="mt-2">
                <vs-col vs-w="6">
                    <vs-select
                      label="Jenis Kelamin"
                      v-model="gender"
                      class="w-5/6"
                      >
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in [{value: 1, text: 'Laki-laki'}, {value: 2, text: 'Perempuan'}]" />
                    </vs-select>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-input name="alphanumeric" label="Alphanumeric" class="w-5/6" v-model="alphanumeric"/>
                </vs-col>
              </vs-row>
              <vs-row class="mt-2">
                <vs-col vs-w="6">
                  <vs-input name="rangeLower" label="Batas Nilai Bawah" class="w-5/6" v-model="rangeLower"/>
                </vs-col>
                <vs-col vs-w="6">
                  <vs-input name="rangeUpper" label="Batas Nilai Atas" class="w-5/6" v-model="rangeUpper"/>
                </vs-col>
              </vs-row>
             </div>
           </vx-card>
       </vs-prompt>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import lab from "@/api/lab";
import master from "@/api/master";
import form from "@/api/form";
import tool from "@/tool/form_tool";
import moment from 'moment';

export default {
  components: {
      Datepicker
  },
  data() {
    return {
			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
      },
      id: null,
    };
  },
  methods: {
		listen(newVal, schema) {
		},
    onConfirm() {
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin untuk menyimpan data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.saveData
        })
    },
    saveData() {
      this.loading = true;
			let config = {
				headers: {
					"content-type": "application/json"
				}
      };

			master.saveSetting(this.model, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.$router.push(
							"/lab/setting/edit"
						);
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				});

		},
		async firstLoad() {
			const frm = await form.getFormSetting();
			this.schema.fields = frm.data.data[0].fields;
			const xmodel = await master.getSetting();
      this.model = xmodel.data.data[0];
    },
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.firstLoad();
  }
};
</script>
